// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"c4a56fe4","542":"f4dd6255","813":"a68fb90b"}[chunkId] + ".chunk.js";
};